import { useRouter } from 'next/router';
import React from 'react';
import DetailsPage from './DetailsPage';

export const VideoEntry = ({ path }) => {
    const router = useRouter();
    const openModal = Boolean(router.query.modalId);

    return <DetailsPage path={path} openModal={openModal} />;
};

export default VideoEntry;
